const AiChatLoadingNames = {
  GENERATING: "generating",
  REGENERATING: "regenerating"
} as const;

export default AiChatLoadingNames;
